import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@curi/react';
import __isEmpty from 'lodash/isEmpty';
import __upperFirst from 'lodash/upperFirst';

import './ButtonWrapper.css';

class Button extends React.Component {
  render() {
    return (
      <div className="button-component-wrapper" type={this.props.type}>
        {
          this.props.type === 'form' ? (
            <input
              id={this.props.id}
              type="submit"
              className={`button ${!__isEmpty(this.props.extraClass) ? this.props.extraClass : ''}`}
              value={this.props.text}
              data-on="click"
              data-event-category="Button - Form"
              data-event-action="Click"
              data-event-label={this.props.text}
            />
          ) : (!__isEmpty(this.props.to)) ? (
            <Link
              className={`button ${!__isEmpty(this.props.extraClass) ? this.props.extraClass : ''}`}
              to={this.props.to} params={this.props.linkParams}
            >
              {this.props.text}
            </Link>
          ) : (!__isEmpty(this.props.href)) ? (
            <a
              className={`button ${!__isEmpty(this.props.extraClass) ? this.props.extraClass : ''}`}
              href={this.props.href}
              target="_blank"
            >
              {this.props.text}
            </a>
          ) : (
                  <button
                    id={this.props.id}
                    className={`button ${!__isEmpty(this.props.extraClass) ? this.props.extraClass : ''}`}
                    onClick={this.props.onClick !== undefined ? (e) => this.props.onClick(e) : undefined}
                    data-on="click"
                    data-event-category={`Button - ${__upperFirst(this.props.type)}`}
                    data-event-action="Click"
                    data-event-label={this.props.text}
                  >
                    {this.props.text}
                  </button>
                )
        }
      </div>
    );
  }
}

Button.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string.isRequired,
  type: PropTypes.string, //form, header, in-page, popup
  onClick: PropTypes.func,
  extraClass: PropTypes.string,
  to: PropTypes.string,
  linkParams: PropTypes.object,
  href: PropTypes.string
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/elements/Button/index.js